<template>
  <nav class="panel service">
    <div class="panel-block">
      <p>{{title}}</p>
    </div>

    <div class="panel-block" v-if="field.fieldtype === 'text'">
      <div class="control is-fullwidth">
        <textarea class="textarea is-small" type="text" :placeholder="title" v-model="field.value"></textarea>
      </div>
    </div>

    <div class="panel-block" v-if="field.fieldtype === 'richtext'">
      <div class="control">
        <quill-editor v-model="field.value" :options="editorOptions"></quill-editor>
        <input type="file" id="getImage" style="display: none;" @change="uploadImage">
      </div>
    </div>

    <template v-if="field.fieldtype === 'image'">
      <div class="panel-block">
        <div class="control is-fullwidth">
          <figure class="image is-5by4">
            <featured-image :mediaId="field.value"></featured-image>
          </figure>
        </div>
      </div>
      <div class="panel-block">
        <div class="control">
          <progress v-if="uploading" class="progress is-primary" :value="progress" max="100"></progress>
          <div class="file" v-else>
            <label class="file-label">
              <input @change="uploadImages" class="file-input" type="file" name="resume" accept=".jpg, .jpeg, .png"/>
              <span class="file-cta">
                <span class="file-icon">
                  <i class="fa fa-upload"></i>
                </span>
                <span class="file-label">
                  Upload a Featured Image…
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </template>

    <template v-if="field.fieldtype === 'gallery'">
      <div class="panel-block">
        <div class="control is-fullwidth">
          <div class="select is-fullwidth">
            <select v-model="field.value">
              <option value="null">Select Gallery</option>
              <option v-for="gallery in galleries" :key="gallery['.key']" :value="gallery['.key']">{{gallery.title}}</option>
            </select>
          </div>
        </div>
      </div>
    </template>

    <div class="panel-block">
      <slot name="footer"></slot>
    </div>
  </nav>
</template>

<script>
import firebase from 'firebase'
import {mediaRef, galleriesRef} from '@/firebase_config'
import editorOptions from './editor-options'

import featuredImage from '../../common/FeaturedImage'

export default {
  props: [
    'title',
    'field'
  ],
  firebase: {
    galleries: galleriesRef
  },
  data () {
    return {
      currentUser: firebase.auth().currentUser,
      uploading: false,
      progress: 0,
      editorOptions
    }
  },
  methods: {
    uploadImages (e) {
      let files = e.target.files
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        this.uploadImage(file)
      }
    },
    uploadImage (file) {
      let storageRef = firebase.storage().ref('images/' + file.name)
      let uploadTask = storageRef.put(file)

      uploadTask.then(this.addImageToMedia)
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, this.handleUploadProgress, this.handleUploadError, this.handleUploadComplete)
    },
    addImageToMedia (snapshot) {
      let mediaObj = {
        src: snapshot.downloadURL,
        path: snapshot.ref.fullPath,
        name: snapshot.metadata.name,
        contentType: snapshot.metadata.contentType,
        createdBy: this.currentUser.uid,
        createdOn: (new Date()).toISOString()
      }

      mediaRef.push(mediaObj).then(ref => {
        this.field.value = ref.key
      })
    },
    handleUploadProgress (snapshot) {
      this.uploading = true
      this.progress = Math.round(snapshot.bytesTransferred * 100 / snapshot.totalBytes)
    },
    handleUploadError () {
      this.uploading = false
      this.progress = 0
    },
    handleUploadComplete () {
      this.uploading = false
      this.progress = 0
    }
  },
  components: {
    featuredImage
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Admin/content/PageField.vue